import { FilterModel } from './../models/filter.model';
import { ProductModel } from '../models/product.model';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges
} from '@angular/core';
import { TableRowModel } from '../models/tablerow.model';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import { TableCellModel } from '../models/tablecell.model';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModelModel } from '../models/model.model';

@Component({
  selector: 'app-product-details-models',
  template: `
  <div>
  <h2 id="models_header" class="modelsHeader">Models</h2>
  <div class="table-responsive">
  <table class="table table-striped">
  <thead>
    <tr>
      <th class="tableHeader">{{headerRow?.firstcell}}</th>
      <th *ngFor="let headCell of headerRow?.orderedcells | orderBy : 'sortorder'" class="tableHeader">
        <label for="{{headCell.uuid}}">
          {{headCell.attributename}}
        </label>
        <br />
        <select id="{{headCell.uuid}}" [attr.aria-label]="headCell.filtermodel.filtername" class="dropdownbox" [(ngModel)]="headCell.filtermodel.selectedvalue" (ngModelChange)="addfilterattribute(headCell.filtermodel.filtername, $event)">
            <option class="availoption" [ngValue]="i" *ngFor="let i of headCell.filtermodel.availablevalues">{{i}}</option>
        </select>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of tableRows">
      <th scope="row" style="text-align: center;"><a class="link" href="{{data?.firstcellLinkText}}"><span class="linktext">{{data?.firstcell}}</span></a><br /><span class="relatedModelsText">{{data?.relatedModels}}</span></th>
      <td *ngFor="let cell of data.orderedcells | orderBy : 'sortorder'" style="text-align: center;">{{cell.value}}</td>
    </tr>
  </tbody>
</table>
</div>
<div style="width:100%;text-align:center;"><button aria-describedby="models_header" *ngIf="numDisplayedRows > 4" class="viewMoreButton" attr.aria-label="{{viewMoreText}}" (click)="viewMore()">{{viewMoreText}}</button></div>
</div>
  `,
  styles: [
    `
      .modelsHeader {
        color: #4a4a4a;
        font-family: 'LGEIBold';
        font-size: 32px;
        text-align: left;
      }

      .linktext {
        color: #a50034;
        font-family: 'LGEIRegular';
        font-size: 16px;
        font-weight: 500;
        text-decoration: none;
      }

      .linktext:hover {
        color: #a50034;
        font-family: 'LGEIRegular';
        font-size: 16px;
        font-weight: bold;
        text-decoration: underline;
      }

      .relatedModelsText {
        color: #4a4a4a;
        font-family: 'LGEIRegular';
        font-size: 10px;
      }

      .dropdownbox {
        border-radius: 5px;
      }

      select.decoration option:hover {
        box-shadow: 0 0 10px 100px #1882a8 inset;
      }

      .availoption:hover {
        color: white !important;
        background-color: #a50034 !important;
      }

      .tableHeader {
        background-color: #a50034;
        color: #ffffff;
        font-family: 'LGEIRegular';
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        line-height: 1.8;
      }

      .viewMoreButton {
        border: 1px solid #a50034;
        border-radius: 4px;
        background-color: #ffffff;
        color: #a50034;
        font-family: 'LGEIRegular';
        font-size: 16px;
        line-height: 2;
        text-align: center;
        width: 150px;
        cursor: pointer;
      }
    `
  ]
})
export class ProductDetailsModelsComponent implements OnChanges, OnInit {
  @Input() model: ProductModel;
  @Input() iscommercial: string;
  @Input() productClass: string;
  tableRows: TableRowModel[] = [];
  headerRow: TableRowModel = new TableRowModel();
  firstAttributeId: string;
  secondAttributeId: string;
  viewMoreToggle: Boolean = true;
  viewMoreText = 'View More';
  viewMoreLabel = 'Click to View more Models';
  inpreviewmode = false;
  showViewMore = true;
  numDisplayedRows = 0;
  filtermodels: FilterModel[] = [];
  allTableRows: TableRowModel[];

  ngOnInit() { }

  ngOnChanges() {
    if (window !== window.top) {
      this.inpreviewmode = true;
    }

    this.headerRow.firstcell = 'Model Number';
    if (this.model.models[0]) {
      for (let i = 0; i < this.model.models.length; i++) {
        if (!this.inpreviewmode) {
          if (
            (!this.model.models[i].publishon ||
              moment(
                this.model.models[i].publishon,
                'MM/DD/YYYY'
              ).isSameOrBefore(moment())) &&
            (!this.model.models[i].unpublishon ||
              moment(this.model.models[i].unpublishon, 'MM/DD/YYYY').isAfter(
                moment()
              ))
          ) {
            let i = 0;
            this.model.models[i].attributes.forEach(a => {
              if (
                a.isdisplayedontypepage &&
                !this.headerRow.orderedcells.find(
                  x => x.attributename == a.name
                )
              ) {
                const tablecell = new TableCellModel();
                tablecell.attributename = a.name;
                tablecell.sortorder = i;
                tablecell.filtermodel = new FilterModel();
                tablecell.filtermodel.filtername = a.name;
                tablecell.filtermodel.availablevalues.push('-select-');
                tablecell.filtermodel.selectedvalue = '-select-';
                this.headerRow.orderedcells.push(tablecell);
                i = i + 1;
              }
            });
          }
        } else {
          if (
            !this.model.models[i].unpublishon ||
            moment(this.model.models[i].unpublishon, 'MM/DD/YYYY').isAfter(
              moment()
            )
          ) {
            let i = 0;
            this.model.models[i].attributes.forEach(a => {
              if (
                a.isdisplayedontypepage &&
                !this.headerRow.orderedcells.find(
                  x => x.attributename == a.name
                )
              ) {
                const tablecell = new TableCellModel();
                tablecell.attributename = a.name;
                tablecell.sortorder = i;
                tablecell.filtermodel = new FilterModel();
                tablecell.filtermodel.filtername = a.name;
                tablecell.filtermodel.availablevalues.push('-select-');
                tablecell.filtermodel.selectedvalue = '-select-';
                this.headerRow.orderedcells.push(tablecell);
                i = i + 1;
              }
            });
          }
        }
      }
      this.viewMoreToggle = false;
      this.viewMore();
      this.viewMoreToggle = true;

      console.log('HEADER ROW:', this.headerRow);

      this.getAllOptions();
    }
  }

 getAllOptions() {
    for (let i = 0; i < this.model.models.length; i++) {
      this.headerRow.orderedcells.forEach(c => {
        this.allTableRows.forEach(x => {
          x.orderedcells.forEach(y => {
            if (c.attributename == y.attributename) {
              if (!c.filtermodel.availablevalues.find(x => x == y.value) && y.value != '' && y.value != null) {
                // if (attValue.value) {
                c.filtermodel.availablevalues.push(y.value);
                // }
              }
            }
          })
        })
        // const attValue = this.model.models[i].attributes.find(
        //   x => x.name == c.attributename
        // );
        // if (attValue) {
        //   if (!c.filtermodel.availablevalues.find(x => x == attValue.value)) {
        //     if (attValue.value) {
        //       c.filtermodel.availablevalues.push(attValue.value);
        //     }
        //   }
        // }
        c.filtermodel.availablevalues = c.filtermodel.availablevalues.sort((val1: string, val2: string) => {

          // Check if string begins with a number
          const regex: RegExp = new RegExp('[+-]?([0-9]*[.])?[0-9]+');
          const val1res = val1.replace(',', '').match(regex);
          const val2res = val2.replace(',', '').match(regex);

          if (val1res && val1res.length && val2res && val2res.length) {
            // both search terms start with numbers. Parse them and search by numerical value vs string value
            const num1 = Number(val1res[0]);
            const num2 = Number(val2res[0]);

            // tslint:disable-next-line:curly
            if (!num1 || !num2) return 0; // shomehow they are no longer numbers

            if (num1 > num2) {
              return 1;
            }

            if (num1 < num2) {
              return -1;
            }

            // If first numbers are equal, check for a / and a second number to compare

            if (!val1.includes('/') || !val2.includes('/')) return 0;

            const val1Split = val1.split('/');
            const val2Split = val2.split('/');

            if (val1Split && val1Split.length && val2Split && val1Split.length) {
              const val1res2 = val1Split[1].trim().replace(',', '').match(regex);
              const val2res2 = val2Split[1].trim().replace(',', '').match(regex);

              if (val1res2 && val1res2.length && val2res2 && val2res2.length) {
                // both search terms start with numbers. Parse them and search by numerical value vs string value
                const num1_2 = Number(val1res2[0]);
                const num2_2 = Number(val2res2[0]);
                // tslint:disable-next-line:curly
                if (!num1_2 || !num2_2) return 0; // shomehow they are no longer numbers
                if (num1_2 > num2_2) {
                  return 1;
                }

                if (num1_2 < num2_2) {
                  return -1;
                }
              }
              return 0;
            }

          } else {
            if (val1 > val2) {
              return 1;
            }

            if (val1 < val2) {
              return -1;
            }
            return 0;
          }
        });
      });
    }

  }

  resetheaderfilters() {
    this.headerRow.orderedcells.forEach(c => {
      c.filtermodel.availablevalues = [];
      c.filtermodel.availablevalues.push('-select-');
      const rowstoloop = this.tableRows.filter(x =>
        x.orderedcells.find(o => o.attributename == c.attributename)
      );
      rowstoloop.forEach(r => {
        const cell = r.orderedcells.find(
          o => o.attributename == c.attributename
        );
        if (cell && cell.value) {
          if (!c.filtermodel.availablevalues.find(x => x == cell.value)) {
            c.filtermodel.availablevalues.push(cell.value);
          }
        }
      });
    });
  }

  addfilterattribute(attributename: string, value: string) {
    const headercell = this.headerRow.orderedcells.find(
      x => x.attributename == attributename
    );
    headercell.filtermodel.selectedvalue = value;
    this.getallmodels();
    this.headerRow.orderedcells.forEach(c => {
      if (c.filtermodel.selectedvalue != '-select-') {
        this.tableRows = this.tableRows.filter(
          x =>
            x.orderedcells.find(o => o.attributename == c.attributename)
              .value == c.filtermodel.selectedvalue
        );
      }
    });

    // this.resetheaderfilters();
  }

  viewMore() {
    this.tableRows = [];
    this.numDisplayedRows = 0;
    for (let i = 0; i < this.model.models.length; i++) {
      this.populaterows(i);
    }
    if (this.viewMoreToggle === true) {
      this.viewMoreToggle = false;
      this.viewMoreText = 'View Fewer';
      this.viewMoreLabel = 'Click to view fewer models'
    } else {
      this.allTableRows= this.tableRows;
      this.tableRows = this.tableRows.slice(0, 4);
      this.viewMoreToggle = true;
      this.viewMoreText = 'View More';
      this.viewMoreLabel = 'Click to View more Models';
    }

    // this.resetheaderfilters();
    this.ordertablerows();
  }

  getallmodels() {
    this.tableRows = [];
    this.numDisplayedRows = 0;
    for (let i = 0; i < this.model.models.length; i++) {
      this.populaterows(i);
    }
  }

  ordertablerows() {
    this.tableRows = this.tableRows.sort(this.dynamicSort('firstcell'));
  }

  dynamicSort(property) {
    let sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      const result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  populaterows(i: number) {
    if (!this.inpreviewmode) {
      if (
        (!this.model.models[i].publishon ||
          moment(this.model.models[i].publishon, 'MM/DD/YYYY').isSameOrBefore(
            moment()
          )) &&
        (!this.model.models[i].unpublishon ||
          moment(this.model.models[i].unpublishon, 'MM/DD/YYYY').isAfter(
            moment()
          )) &&
        this.model.models[i].shouldDisplayModel(
          this.iscommercial,
          this.productClass
        )
      ) {
        this.addRow(i);
        this.numDisplayedRows++;
      }
    } else {
      if (
        !this.model.models[i].unpublishon ||
        (moment(this.model.models[i].unpublishon, 'MM/DD/YYYY').isAfter(
          moment()
        ) &&
          this.model.models[i].shouldDisplayModel(
            this.iscommercial,
            this.productClass
          ))
      ) {
        this.addRow(i);
        this.numDisplayedRows++;
      }
    }
    this.ordertablerows();
  }

  addRow(i: number) {
    const newRow: TableRowModel = new TableRowModel();
    newRow.firstcellLinkText = `${environment.umbracoUrl}${this.iscommercial == 'true'
        ? 'commercial'
        : 'residential-light-commercial'
      }/product-type/model-details/?productTypeId=${this.model.id}&modelId=${this.model.models[i].id
      }&modelNumber=${this.model.models[i].modelNumber}&iscommercial=${this.iscommercial == 'true' ? 'true' : 'false'
      }`;
    if (this.productClass) {
      newRow.firstcellLinkText += '&class=' + encodeURI(this.productClass);
    }
    newRow.firstcell = this.model.models[i].modelNumber;
    if (
      this.model.models[i].includes &&
      this.model.models[i].includes.length > 0
    ) {
      newRow.relatedModels = '(';
      this.model.models[i].includes.forEach(x => {
        if (newRow.relatedModels != '(') {
          newRow.relatedModels = newRow.relatedModels + '+';
        }
        newRow.relatedModels = newRow.relatedModels + x.modelNumber;
      });
      newRow.relatedModels = newRow.relatedModels + ')';
    }

    this.headerRow.orderedcells.forEach(c => {
      const attValue = this.model.models[i].attributes.find(
        x => x.name == c.attributename
      );
      if (attValue) {
        const tablecell = new TableCellModel();
        tablecell.attributename = c.attributename;
        tablecell.sortorder = c.sortorder;
        tablecell.value = attValue.value;
        newRow.orderedcells.push(tablecell);
      } else {
        if (c.filtermodel.availablevalues.includes('') === false) {
          c.filtermodel.availablevalues.push('');
        }

        const tablecell = new TableCellModel();
        tablecell.attributename = c.attributename;
        tablecell.sortorder = c.sortorder;
        tablecell.value = '';
        newRow.orderedcells.push(tablecell);
      }
    });

    this.tableRows.push(newRow);
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/product-details-models.component.ts